export const SvgBack = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.9167 16.3334L7.08341 10.5L12.9167 4.66669"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
// main nav icon
export const SvgHome = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.07861 16.1354H14.8936"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.3999 13.713C2.3999 8.082 3.0139 8.475 6.3189 5.41C7.7649 4.246 10.0149 2 11.9579 2C13.8999 2 16.1949 4.235 17.6539 5.41C20.9589 8.475 21.5719 8.082 21.5719 13.713C21.5719 22 19.6129 22 11.9859 22C4.3589 22 2.3999 22 2.3999 13.713Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgHomeFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.40039 13.713C2.40039 8.082 3.01439 8.475 6.31939 5.41C7.76539 4.246 10.0154 2 11.9584 2C13.9004 2 16.1954 4.235 17.6544 5.41C20.9594 8.475 21.5724 8.082 21.5724 13.713C21.5724 22 19.6134 22 11.9864 22C4.35939 22 2.40039 22 2.40039 13.713Z"
      fill="#7C68FB"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M9.07812 16.1353H14.8931H9.07812Z" fill="white" />
    <path d="M9.07812 16.1353H14.8931" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SvgTeam = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9726 20.3682C8.73355 20.3682 5.96655 19.8782 5.96655 17.9162C5.96655 15.9542 8.71555 14.2462 11.9726 14.2462C15.2116 14.2462 17.9786 15.9382 17.9786 17.8992C17.9786 19.8602 15.2296 20.3682 11.9726 20.3682Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9726 11.4487C14.0986 11.4487 15.8226 9.72569 15.8226 7.59969C15.8226 5.47369 14.0986 3.74969 11.9726 3.74969C9.84657 3.74969 8.12257 5.47369 8.12257 7.59969C8.11657 9.71769 9.82657 11.4417 11.9456 11.4487H11.9726Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.362 10.3916C19.599 10.0606 20.511 8.9326 20.511 7.5896C20.511 6.1886 19.518 5.0186 18.196 4.7486"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.9431 13.5444C20.6971 13.5444 22.1951 14.7334 22.1951 15.7954C22.1951 16.4204 21.6781 17.1014 20.8941 17.2854"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.58384 10.3916C4.34584 10.0606 3.43384 8.9326 3.43384 7.5896C3.43384 6.1886 4.42784 5.0186 5.74884 4.7486"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.00176 13.5444C3.24776 13.5444 1.74976 14.7334 1.74976 15.7954C1.74976 16.4204 2.26676 17.1014 3.05176 17.2854"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgTeamFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1583 8.23285C16.1583 10.5825 14.2851 12.4666 11.949 12.4666C9.61292 12.4666 7.73974 10.5825 7.73974 8.23285C7.73974 5.88227 9.61292 4 11.949 4C14.2851 4 16.1583 5.88227 16.1583 8.23285ZM11.949 20C8.51785 20 5.58809 19.456 5.58809 17.2802C5.58809 15.1034 8.49904 14.5396 11.949 14.5396C15.3802 14.5396 18.31 15.0836 18.31 17.2604C18.31 19.4362 15.399 20 11.949 20ZM17.9571 8.30922C17.9571 9.50703 17.5998 10.6229 16.973 11.5505C16.9086 11.646 16.9659 11.7748 17.0796 11.7946C17.2363 11.8216 17.3984 11.8369 17.5631 11.8414C19.2062 11.8846 20.6809 10.821 21.0883 9.21974C21.6918 6.84123 19.9198 4.7059 17.6634 4.7059C17.4181 4.7059 17.1835 4.73201 16.9551 4.77884C16.9238 4.78605 16.8907 4.80046 16.8728 4.82838C16.8513 4.8626 16.8674 4.90853 16.8889 4.93825C17.5667 5.8938 17.9571 7.05918 17.9571 8.30922ZM20.6782 13.5126C21.7823 13.7296 22.5084 14.1727 22.8093 14.8166C23.0636 15.3453 23.0636 15.9586 22.8093 16.4864C22.349 17.4851 20.8654 17.8058 20.2887 17.8886C20.1696 17.9066 20.0738 17.8031 20.0864 17.6833C20.3809 14.9157 18.0377 13.6035 17.4315 13.3018C17.4055 13.2883 17.4002 13.2676 17.4028 13.255C17.4046 13.246 17.4154 13.2316 17.4351 13.2289C18.7468 13.2046 20.1571 13.3847 20.6782 13.5126ZM6.43711 11.8413C6.60186 11.8368 6.76304 11.8224 6.92063 11.7945C7.03434 11.7747 7.09165 11.6459 7.02718 11.5504C6.4004 10.6228 6.04313 9.50694 6.04313 8.30913C6.04313 7.05909 6.43353 5.89371 7.11135 4.93816C7.13284 4.90844 7.14806 4.86251 7.12746 4.82829C7.10956 4.80127 7.07553 4.78596 7.04509 4.77875C6.81586 4.73192 6.58127 4.70581 6.33593 4.70581C4.07951 4.70581 2.30751 6.84114 2.91191 9.21965C3.31932 10.8209 4.79405 11.8845 6.43711 11.8413ZM6.59694 13.2545C6.59962 13.268 6.59425 13.2878 6.56918 13.3022C5.9621 13.6039 3.61883 14.9161 3.91342 17.6827C3.92595 17.8034 3.83104 17.9061 3.71195 17.889C3.13531 17.8061 1.65163 17.4855 1.19139 16.4867C0.936203 15.9581 0.936203 15.3457 1.19139 14.817C1.49225 14.1731 2.21752 13.73 3.32156 13.512C3.84358 13.385 5.25294 13.2049 6.5656 13.2292C6.5853 13.2319 6.59515 13.2464 6.59694 13.2545Z"
      fill="#7C68FB"
    />
  </svg>
);

export const SvgAccount = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.1437 17.8828H4.67114"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2051 17.8837C15.2051 19.9255 15.886 20.6055 17.9269 20.6055C19.9678 20.6055 20.6487 19.9255 20.6487 17.8837C20.6487 15.8419 19.9678 15.1619 17.9269 15.1619C15.886 15.1619 15.2051 15.8419 15.2051 17.8837Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1768 7.39418H20.6484"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1154 7.39284C10.1154 5.35195 9.43448 4.67105 7.39358 4.67105C5.35179 4.67105 4.6709 5.35195 4.6709 7.39284C4.6709 9.43463 5.35179 10.1146 7.39358 10.1146C9.43448 10.1146 10.1154 9.43463 10.1154 7.39284Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgAccountFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.1439 17.8828H4.67139"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2051 17.8837C15.2051 19.9254 15.886 20.6054 17.9269 20.6054C19.9678 20.6054 20.6487 19.9254 20.6487 17.8837C20.6487 15.8419 19.9678 15.1619 17.9269 15.1619C15.886 15.1619 15.2051 15.8419 15.2051 17.8837Z"
      fill="#7C68FB"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1768 7.39415H20.6484"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1154 7.39281C10.1154 5.35192 9.43448 4.67102 7.39358 4.67102C5.35179 4.67102 4.6709 5.35192 4.6709 7.39281C4.6709 9.4346 5.35179 10.1146 7.39358 10.1146C9.43448 10.1146 10.1154 9.4346 10.1154 7.39281Z"
      fill="#7C68FB"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgOpenApi = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.91699 14.8539L9.90999 10.9649L13.324 13.6449L16.253 9.8649"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6671 2.35001C20.7291 2.35001 21.5891 3.21001 21.5891 4.27201C21.5891 5.33301 20.7291 6.19401 19.6671 6.19401C18.6051 6.19401 17.7451 5.33301 17.7451 4.27201C17.7451 3.21001 18.6051 2.35001 19.6671 2.35001Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.7555 9.26901C20.8885 10.164 20.9495 11.172 20.9495 12.303C20.9495 19.241 18.6375 21.553 11.6995 21.553C4.76246 21.553 2.44946 19.241 2.44946 12.303C2.44946 5.36601 4.76246 3.05301 11.6995 3.05301C12.8095 3.05301 13.8005 3.11201 14.6825 3.24001"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgOpenApiFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2428 4.73756C15.2428 6.95855 17.0459 8.75902 19.2702 8.75902C19.5151 8.75782 19.7594 8.73431 20 8.68878V16.6615C20 20.0156 18.0215 22 14.6624 22H7.34636C3.97851 22 2 20.0156 2 16.6615V9.3561C2 6.00195 3.97851 4 7.34636 4H15.3131C15.2659 4.243 15.2423 4.49001 15.2428 4.73756ZM13.15 14.8966L16.0078 11.2088V11.1912C16.2525 10.8625 16.1901 10.3989 15.8671 10.1463C15.7108 10.0257 15.5122 9.97345 15.3167 10.0016C15.1211 10.0297 14.9453 10.1358 14.8295 10.2956L12.4201 13.3951L9.6766 11.2351C9.51997 11.1131 9.32071 11.0592 9.12381 11.0856C8.92691 11.1121 8.74898 11.2166 8.63019 11.3756L5.67562 15.1863C5.57177 15.3158 5.51586 15.4771 5.51734 15.6429C5.5002 15.9781 5.71187 16.2826 6.03238 16.3838C6.35288 16.485 6.70138 16.3573 6.88031 16.0732L9.35125 12.8771L12.0948 15.0283C12.2508 15.1541 12.4514 15.2111 12.6504 15.1863C12.8494 15.1615 13.0297 15.0569 13.15 14.8966Z"
      fill="#7C68FB"
    />
    <circle cx="19.5" cy="4.5" r="2.5" fill="#7C68FB" />
  </svg>
);

export const SvgApiKey = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6889 12.0001C10.6889 13.0231 9.85986 13.8521 8.83686 13.8521C7.81386 13.8521 6.98486 13.0231 6.98486 12.0001C6.98486 10.9771 7.81386 10.1481 8.83686 10.1481H8.83986C9.86186 10.1491 10.6889 10.9781 10.6889 12.0001Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6919 12.0001H17.0099V13.8521"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1821 13.8521V12.0001"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.75 12.0001C2.75 5.06311 5.063 2.75011 12 2.75011C18.937 2.75011 21.25 5.06311 21.25 12.0001C21.25 18.9371 18.937 21.2501 12 21.2501C5.063 21.2501 2.75 18.9371 2.75 12.0001Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgApiKeyFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Property 1=Present, Property 2=API Keys">
      <g id="Password">
        <path
          id="Fill 1"
          d="M16.3345 1.99976H7.66549C4.27649 1.99976 2.00049 4.37776 2.00049 7.91676V16.0838C2.00049 19.6218 4.27649 21.9998 7.66549 21.9998H16.3335C19.7225 21.9998 22.0005 19.6218 22.0005 16.0838V7.91676C22.0005 4.37776 19.7235 1.99976 16.3345 1.99976Z"
          fill="#7C68FB"
        />
        <path
          id="Combined Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3144 11.2484H17.0144C17.4244 11.2484 17.7644 11.5884 17.7644 11.9984V13.8484C17.7644 14.2684 17.4244 14.5984 17.0144 14.5984C16.5944 14.5984 16.2644 14.2684 16.2644 13.8484V12.7484H14.9344V13.8484C14.9344 14.2684 14.5944 14.5984 14.1844 14.5984C13.7644 14.5984 13.4344 14.2684 13.4344 13.8484V12.7484H11.3144C10.9944 13.8184 10.0144 14.5984 8.84437 14.5984C7.40437 14.5984 6.23438 13.4384 6.23438 11.9984C6.23438 10.5684 7.40437 9.39844 8.84437 9.39844C10.0144 9.39844 10.9944 10.1784 11.3144 11.2484ZM7.73438 11.9984C7.73438 12.6084 8.23438 13.0984 8.84438 13.0984C9.44438 13.0984 9.94438 12.6084 9.94438 11.9984C9.94438 11.3884 9.44438 10.8984 8.84438 10.8984C8.23438 10.8984 7.73438 11.3884 7.73438 11.9984Z"
          fill="white"
        />
      </g>
    </g>
  </svg>
);

// bot nav icon
export const SvgDashboard = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2779 13.8891C17.9527 13.8891 18.519 14.446 18.4158 15.1123C17.8106 19.0323 14.4548 21.9428 10.4074 21.9428C5.92952 21.9428 2.30005 18.3134 2.30005 13.8365C2.30005 10.1481 5.10215 6.7123 8.25689 5.93546C8.93479 5.76809 9.62952 6.24493 9.62952 6.94283C9.62952 11.6712 9.78847 12.8944 10.6864 13.5597C11.5843 14.2249 12.64 13.8891 17.2779 13.8891Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6926 9.95157C21.7463 6.91368 18.0147 2.01684 13.4674 2.10105C13.1137 2.10736 12.8305 2.4021 12.8147 2.75473C12.7 5.25263 12.8547 8.48947 12.9411 9.95684C12.9674 10.4137 13.3263 10.7726 13.7821 10.7989C15.2905 10.8853 18.6453 11.0032 21.1074 10.6305C21.4421 10.58 21.6874 10.2895 21.6926 9.95157Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgDashboardFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2779 13.8891C17.9527 13.8891 18.519 14.446 18.4158 15.1123C17.8106 19.0323 14.4548 21.9428 10.4074 21.9428C5.92952 21.9428 2.30005 18.3134 2.30005 13.8365C2.30005 10.1481 5.10215 6.7123 8.25689 5.93546C8.93479 5.76809 9.62952 6.24493 9.62952 6.94283C9.62952 11.6712 9.78847 12.8944 10.6864 13.5597C11.5843 14.2249 12.64 13.8891 17.2779 13.8891Z"
      fill="#7C68FB"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6926 9.95157C21.7463 6.91368 18.0147 2.01684 13.4674 2.10105C13.1137 2.10736 12.8305 2.4021 12.8147 2.75473C12.7 5.25263 12.8547 8.48947 12.9411 9.95684C12.9674 10.4137 13.3263 10.7726 13.7821 10.7989C15.2905 10.8853 18.6453 11.0032 21.1074 10.6305C21.4421 10.58 21.6874 10.2895 21.6926 9.95157Z"
      fill="#7C68FB"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgMessage = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.0944 19.0711C16.8228 21.3427 12.0054 23.3067 8.09562 20.8906C7.87804 20.7561 7.76925 20.6889 7.68699 20.6563C7.52971 20.594 7.41043 20.576 7.24178 20.589C7.15356 20.5958 7.05362 20.6217 6.85373 20.6736C5.59593 20.9996 4.96704 21.1626 4.51396 21.0704C3.72759 20.9103 3.11302 20.2958 2.95298 19.5094C2.86078 19.0563 3.02378 18.4274 3.34979 17.1696C3.40161 16.9697 3.42752 16.8697 3.43431 16.7812C3.44725 16.6126 3.42886 16.4919 3.36627 16.3347C3.33344 16.2523 3.2663 16.1442 3.13203 15.9282C0.707556 12.0269 2.58389 7.29732 4.95228 4.92893C8.85752 1.02369 15.1892 1.02369 19.0944 4.92893C22.9997 8.83418 22.9997 15.1658 19.0944 19.0711Z"
      stroke="#667085"
      strokeWidth="1.5"
    />
    <path
      d="M9.05273 11.8578C9.05273 12.4101 8.60502 12.8578 8.05273 12.8578C7.50045 12.8578 7.05273 12.4101 7.05273 11.8578C7.05273 11.3055 7.50045 10.8578 8.05273 10.8578C8.60502 10.8578 9.05273 11.3055 9.05273 11.8578Z"
      fill="#667085"
    />
    <path
      d="M13.0527 11.8578C13.0527 12.4101 12.605 12.8578 12.0527 12.8578C11.5004 12.8578 11.0527 12.4101 11.0527 11.8578C11.0527 11.3055 11.5004 10.8578 12.0527 10.8578C12.605 10.8578 13.0527 11.3055 13.0527 11.8578Z"
      fill="#667085"
    />
    <path
      d="M17.0527 11.8578C17.0527 12.4101 16.605 12.8578 16.0527 12.8578C15.5005 12.8578 15.0527 12.4101 15.0527 11.8578C15.0527 11.3055 15.5005 10.8578 16.0527 10.8578C16.605 10.8578 17.0527 11.3055 17.0527 11.8578Z"
      fill="#667085"
    />
  </svg>
);

export const SvgMessageFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.09562 20.8906C12.0054 23.3067 16.8228 21.3427 19.0944 19.0711C22.9997 15.1658 22.9997 8.83418 19.0944 4.92893C15.1892 1.02369 8.85752 1.02369 4.95228 4.92893C2.58389 7.29732 0.707556 12.0269 3.13203 15.9282C3.26629 16.1442 3.33344 16.2523 3.36627 16.3347C3.42886 16.4919 3.44725 16.6126 3.43431 16.7812C3.42752 16.8697 3.40161 16.9697 3.34979 17.1696C3.02378 18.4274 2.86078 19.0563 2.95298 19.5094C3.11302 20.2958 3.72759 20.9103 4.51396 21.0704C4.96704 21.1626 5.59593 20.9996 6.85373 20.6736C7.05359 20.6218 7.15357 20.5958 7.24178 20.589C7.41043 20.576 7.52971 20.594 7.68699 20.6563C7.76925 20.6889 7.87804 20.7561 8.09562 20.8906ZM9.05273 11.8578C9.05273 12.4101 8.60502 12.8578 8.05273 12.8578C7.50045 12.8578 7.05273 12.4101 7.05273 11.8578C7.05273 11.3055 7.50045 10.8578 8.05273 10.8578C8.60502 10.8578 9.05273 11.3055 9.05273 11.8578ZM13.0527 11.8578C13.0527 12.4101 12.605 12.8578 12.0527 12.8578C11.5005 12.8578 11.0527 12.4101 11.0527 11.8578C11.0527 11.3055 11.5005 10.8578 12.0527 10.8578C12.605 10.8578 13.0527 11.3055 13.0527 11.8578ZM16.0527 12.8578C16.605 12.8578 17.0527 12.4101 17.0527 11.8578C17.0527 11.3055 16.605 10.8578 16.0527 10.8578C15.5005 10.8578 15.0527 11.3055 15.0527 11.8578C15.0527 12.4101 15.5005 12.8578 16.0527 12.8578Z"
      fill="#7C68FB"
    />
  </svg>
);

export const SvgSource = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.3055 15.4498H8.90552"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.2605 11.4385H8.90454"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1599 8.29988L14.4899 2.89988C13.7599 2.79988 12.9399 2.74988 12.0399 2.74988C5.7499 2.74988 3.6499 5.06988 3.6499 11.9999C3.6499 18.9399 5.7499 21.2499 12.0399 21.2499C18.3399 21.2499 20.4399 18.9399 20.4399 11.9999C20.4399 10.5799 20.3499 9.34988 20.1599 8.29988Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9343 2.83252V5.49352C13.9343 7.35152 15.4403 8.85652 17.2983 8.85652H20.2493"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgSourceFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.445 2.9L20.115 8.3C20.1209 8.33281 20.1268 8.3658 20.1325 8.39897C20.1268 8.36582 20.1209 8.33285 20.115 8.30006L19.9118 8.10658H17.2534C15.8093 8.10658 14.6394 6.93707 14.6394 5.49358V3.08522L14.445 2.90006C14.0373 2.84421 13.6015 2.80395 13.1394 2.7793V2.83258V5.49358C13.1394 7.76608 14.9815 9.60658 17.2534 9.60658H20.2044H20.2918C20.2918 9.60657 20.2918 9.60657 20.2918 9.60656C20.3613 10.3349 20.395 11.1319 20.395 12C20.395 18.94 18.295 21.25 11.995 21.25C5.70498 21.25 3.60498 18.94 3.60498 12C3.60498 5.07 5.70498 2.75 11.995 2.75C12.895 2.75 13.715 2.8 14.445 2.9Z"
      fill="#7C68FB"
    />
    <path d="M14.2606 15.4497H8.8606" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.2156 11.4385H8.85962" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SvgConversation = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.41388 8.76099C4.74878 7.00204 5.59659 5.32081 6.95587 3.95982C10.5644 0.346725 16.4154 0.346725 20.024 3.95982C21.1248 5.06202 22.097 6.69355 22.5221 8.50489C22.9499 10.3272 22.8313 12.3742 21.676 14.2356C21.6168 14.3309 21.5802 14.3899 21.5544 14.4341C21.5425 14.4545 21.5362 14.4661 21.5336 14.4711C21.5311 14.4775 21.5297 14.4819 21.5288 14.4847C21.5288 14.488 21.5289 14.4936 21.5295 14.5021C21.5302 14.506 21.5319 14.5147 21.5352 14.5295C21.5438 14.5674 21.5568 14.618 21.5799 14.7074L21.5866 14.7334C21.7193 15.2459 21.8284 15.6672 21.8925 16.0076C21.957 16.3502 21.9944 16.696 21.9257 17.0337C21.73 17.9967 20.9782 18.75 20.0152 18.9462C19.6774 19.015 19.3316 18.9776 18.9893 18.9129C18.6492 18.8487 18.2284 18.7395 17.7165 18.6067L17.6906 18.5999C17.6013 18.5768 17.5507 18.5637 17.513 18.5552C17.4983 18.5518 17.4897 18.5502 17.4857 18.5495C17.4779 18.5489 17.4725 18.5488 17.4692 18.5487C17.4664 18.5496 17.4622 18.5511 17.4564 18.5532C17.4514 18.5559 17.4396 18.5622 17.4191 18.5742C17.3746 18.6002 17.3151 18.6369 17.2192 18.6962C16.5993 19.0798 15.9541 19.3479 15.3005 19.5177C15.058 19.8554 14.7854 20.1778 14.4826 20.4808C13.5908 21.3739 12.2285 22.1843 10.7111 22.5478C9.1832 22.9137 7.44238 22.8371 5.86718 21.8624C5.79079 21.8151 5.74412 21.7863 5.7097 21.7661C5.68224 21.7727 5.64448 21.7824 5.58189 21.7986L5.55666 21.8052C5.13844 21.9137 4.78817 22.0046 4.50368 22.0584C4.21699 22.1125 3.91168 22.1473 3.60781 22.0854C2.76267 21.9132 2.10293 21.252 1.93118 20.4071C1.86945 20.1034 1.90413 19.7981 1.95818 19.5112C2.01181 19.2264 2.10258 18.8758 2.21099 18.457L2.21753 18.4318C2.23393 18.3684 2.24368 18.3305 2.25022 18.3029C2.23012 18.2687 2.20143 18.2224 2.15411 18.1461C1.18042 16.5774 1.08236 14.8541 1.44087 13.3267C1.79681 11.8103 2.60998 10.445 3.53337 9.52044C3.81159 9.24187 4.10608 8.98867 4.41388 8.76099ZM8.0172 5.01982C11.0398 1.99339 15.9401 1.99339 18.9627 5.01982C19.8726 5.93094 20.7024 7.31632 21.0618 8.84766C21.4187 10.368 21.3046 11.9895 20.4015 13.4445C20.393 13.4583 20.3843 13.4722 20.3756 13.4862C20.2895 13.6244 20.1967 13.7733 20.143 13.9084C20.0476 14.1482 20.0146 14.3652 20.0343 14.6225C20.0454 14.7671 20.0842 14.9161 20.1184 15.0471C20.1216 15.0593 20.1247 15.0714 20.1278 15.0833C20.2689 15.6282 20.3648 16.0004 20.4184 16.2852C20.4727 16.5735 20.4654 16.6875 20.4558 16.735C20.3798 17.109 20.088 17.4005 19.7157 17.4764C19.6689 17.4859 19.5554 17.4933 19.2676 17.439C18.9833 17.3853 18.6117 17.2893 18.0674 17.148C18.0555 17.1449 18.0434 17.1418 18.0311 17.1386C17.9005 17.1044 17.7516 17.0655 17.6074 17.0544C17.3503 17.0345 17.1347 17.0671 16.8951 17.1621C16.7603 17.2156 16.6109 17.3083 16.472 17.3946C16.4579 17.4034 16.4439 17.4121 16.43 17.4207C16.4026 17.4376 16.3752 17.4542 16.3478 17.4705C17.252 14.7706 16.6309 11.6714 14.4826 9.52044C12.2563 7.2913 9.01213 6.70388 6.24874 7.75716C6.62506 6.75929 7.21437 5.82365 8.0172 5.01982ZM5.52033 9.81521C7.94742 8.17382 11.2731 8.4295 13.4213 10.5804C15.5519 12.7137 15.8212 16.0073 14.2263 18.4329C13.997 18.7817 13.7288 19.113 13.4213 19.4208C12.7249 20.1181 11.6089 20.7903 10.3617 21.089C9.12503 21.3852 7.81491 21.3036 6.65644 20.5868C6.64495 20.5797 6.63315 20.5724 6.62108 20.5649C6.50954 20.4955 6.37549 20.4122 6.25253 20.3634C6.03646 20.2777 5.83873 20.2478 5.60696 20.2657C5.47555 20.2759 5.34093 20.3112 5.23568 20.3388C5.22518 20.3415 5.21498 20.3442 5.2051 20.3467C4.75505 20.4635 4.45412 20.5412 4.22539 20.5844C3.99317 20.6282 3.92023 20.6182 3.90731 20.6156C3.65282 20.5637 3.45317 20.3644 3.40113 20.1083C3.39839 20.0948 3.38846 20.0214 3.43227 19.7888C3.47542 19.5596 3.55303 19.2582 3.66966 18.8077C3.67222 18.7978 3.67489 18.7876 3.67763 18.7771C3.7052 18.6716 3.74041 18.5368 3.7505 18.4051C3.76828 18.1731 3.73801 17.9742 3.65202 17.758C3.60301 17.6348 3.51967 17.5012 3.45043 17.3902C3.44296 17.3782 3.43566 17.3665 3.42858 17.3551C2.70711 16.1927 2.61355 14.8949 2.90118 13.6695C3.19139 12.4331 3.86214 11.3139 4.5947 10.5804C4.88414 10.2906 5.19437 10.0357 5.52033 9.81521Z"
      fill="#667085"
    />
    <path
      d="M10.9998 15C10.9998 15.5523 11.4476 16 11.9998 16C12.5521 16 12.9998 15.5523 12.9998 15C12.9998 14.4477 12.5521 14 11.9998 14C11.4476 14 10.9998 14.4477 10.9998 15Z"
      fill="#667085"
    />
    <path
      d="M7.99985 15C7.99985 15.5523 8.44756 16 8.99985 16C9.55213 16 9.99985 15.5523 9.99985 15C9.99985 14.4477 9.55213 14 8.99985 14C8.44756 14 7.99985 14.4477 7.99985 15Z"
      fill="#667085"
    />
    <path
      d="M4.99985 15C4.99985 15.5523 5.44756 16 5.99985 16C6.55213 16 6.99985 15.5523 6.99985 15C6.99985 14.4477 6.55213 14 5.99985 14C5.44756 14 4.99985 14.4477 4.99985 15Z"
      fill="#667085"
    />
  </svg>
);

export const SvgConversationFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.42183 7.84948C8.41657 6.34256 12.1604 6.84052 14.6601 9.34336C17.0979 11.7843 17.6313 15.41 16.2601 18.3693C16.4505 18.277 16.6389 18.1736 16.825 18.0585C17.0097 17.9441 17.1021 17.887 17.1719 17.8593C17.3055 17.8064 17.4067 17.791 17.5499 17.8021C17.6248 17.8079 17.7097 17.8299 17.8793 17.874C18.9472 18.1511 19.4812 18.2897 19.8659 18.2113C20.5335 18.0753 21.0553 17.5528 21.1912 16.8843C21.2694 16.4992 21.1311 15.9646 20.8543 14.8954C20.8103 14.7254 20.7883 14.6404 20.7825 14.5652C20.7715 14.4218 20.7871 14.3192 20.8403 14.1856C20.8681 14.1155 20.9251 14.0237 21.0391 13.8401C23.0975 10.5236 21.5045 6.50314 19.4937 4.48982C16.1782 1.17006 10.8025 1.17006 7.48694 4.48982C6.51173 5.46626 5.82336 6.62113 5.42183 7.84948Z"
      fill="#7C68FB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.26243 21.2246C8.99611 22.9161 12.3643 21.5411 13.9526 19.9508C16.6831 17.2169 16.6831 12.7844 13.9526 10.0504C11.2221 7.31652 6.79514 7.31652 4.06466 10.0504C2.40872 11.7085 1.09682 15.0195 2.79197 17.7506C2.88585 17.9019 2.93279 17.9775 2.95575 18.0352C2.99951 18.1453 3.01237 18.2297 3.00332 18.3478C2.99857 18.4098 2.98046 18.4797 2.94423 18.6197C2.71629 19.5002 2.60231 19.9405 2.66678 20.2577C2.77868 20.8082 3.20837 21.2384 3.75819 21.3505C4.07497 21.415 4.51469 21.3009 5.39412 21.0727C5.53386 21.0364 5.60376 21.0183 5.66544 21.0135C5.78336 21.0044 5.86676 21.017 5.97672 21.0606C6.03424 21.0834 6.1103 21.1305 6.26243 21.2246ZM11.0005 15C11.0005 15.5523 11.4482 16 12.0005 16C12.5528 16 13.0005 15.5523 13.0005 15C13.0005 14.4477 12.5528 14 12.0005 14C11.4482 14 11.0005 14.4477 11.0005 15ZM8.00047 15C8.00047 15.5523 8.44819 16 9.00047 16C9.55276 16 10.0005 15.5523 10.0005 15C10.0005 14.4477 9.55276 14 9.00047 14C8.44819 14 8.00047 14.4477 8.00047 15ZM6.00047 16C5.44819 16 5.00047 15.5523 5.00047 15C5.00047 14.4477 5.44819 14 6.00047 14C6.55276 14 7.00047 14.4477 7.00047 15C7.00047 15.5523 6.55276 16 6.00047 16Z"
      fill="#7C68FB"
    />
  </svg>
);
export const SvgWidget = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.14537 3.27077C7.84076 3.24999 7.46972 3.24999 7.02527 3.25H6.97475C6.53029 3.24999 6.15925 3.24999 5.85464 3.27077C5.53754 3.29241 5.23801 3.33905 4.94762 3.45933C4.27379 3.73844 3.73844 4.27379 3.45933 4.94762C3.33905 5.23801 3.29241 5.53754 3.27077 5.85464C3.24999 6.15925 3.24999 6.53028 3.25 6.97474V7.02525C3.24999 7.46971 3.24999 7.84076 3.27077 8.14537C3.29241 8.46247 3.33905 8.76199 3.45933 9.05238C3.73844 9.72621 4.27379 10.2616 4.94762 10.5407C5.23801 10.661 5.53754 10.7076 5.85464 10.7292C6.15925 10.75 6.53028 10.75 6.97474 10.75H7.02526C7.46972 10.75 7.84075 10.75 8.14537 10.7292C8.46247 10.7076 8.76199 10.661 9.05238 10.5407C9.72621 10.2616 10.2616 9.72621 10.5407 9.05238C10.661 8.76199 10.7076 8.46247 10.7292 8.14537C10.75 7.84075 10.75 7.46972 10.75 7.02526V6.97474C10.75 6.53028 10.75 6.15925 10.7292 5.85464C10.7076 5.53754 10.661 5.23801 10.5407 4.94762C10.2616 4.27379 9.72621 3.73844 9.05238 3.45933C8.76199 3.33905 8.46247 3.29241 8.14537 3.27077ZM5.52165 4.84515C5.5988 4.81319 5.71602 4.78372 5.95674 4.76729C6.20421 4.75041 6.5238 4.75 7 4.75C7.4762 4.75 7.7958 4.75041 8.04326 4.76729C8.28399 4.78372 8.4012 4.81319 8.47836 4.84515C8.78464 4.97202 9.02798 5.21536 9.15485 5.52165C9.18681 5.5988 9.21629 5.71602 9.23271 5.95674C9.24959 6.20421 9.25 6.5238 9.25 7C9.25 7.4762 9.24959 7.7958 9.23271 8.04326C9.21629 8.28399 9.18681 8.4012 9.15485 8.47836C9.02798 8.78464 8.78464 9.02798 8.47836 9.15485C8.4012 9.18681 8.28399 9.21629 8.04326 9.23271C7.7958 9.24959 7.4762 9.25 7 9.25C6.5238 9.25 6.20421 9.24959 5.95674 9.23271C5.71602 9.21629 5.5988 9.18681 5.52165 9.15485C5.21536 9.02798 4.97202 8.78464 4.84515 8.47836C4.81319 8.4012 4.78372 8.28399 4.76729 8.04326C4.75041 7.7958 4.75 7.4762 4.75 7C4.75 6.5238 4.75041 6.20421 4.76729 5.95674C4.78372 5.71602 4.81319 5.5988 4.84515 5.52165C4.97202 5.21536 5.21536 4.97202 5.52165 4.84515Z"
      fill="#667085"
    />
    <path
      d="M17.75 4C17.75 3.58579 17.4142 3.25 17 3.25C16.5858 3.25 16.25 3.58579 16.25 4V6.25H14C13.5858 6.25 13.25 6.58579 13.25 7C13.25 7.41421 13.5858 7.75 14 7.75H16.25V10C16.25 10.4142 16.5858 10.75 17 10.75C17.4142 10.75 17.75 10.4142 17.75 10V7.75H20C20.4142 7.75 20.75 7.41421 20.75 7C20.75 6.58579 20.4142 6.25 20 6.25H17.75V4Z"
      fill="#667085"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.14537 13.2708C7.84075 13.25 7.46972 13.25 7.02526 13.25H6.97474C6.53028 13.25 6.15925 13.25 5.85464 13.2708C5.53754 13.2924 5.23801 13.339 4.94762 13.4593C4.27379 13.7384 3.73844 14.2738 3.45933 14.9476C3.33905 15.238 3.29241 15.5375 3.27077 15.8546C3.24999 16.1592 3.24999 16.5303 3.25 16.9747V17.0253C3.24999 17.4697 3.24999 17.8408 3.27077 18.1454C3.29241 18.4625 3.33905 18.762 3.45933 19.0524C3.73844 19.7262 4.27379 20.2616 4.94762 20.5407C5.23801 20.661 5.53754 20.7076 5.85464 20.7292C6.15925 20.75 6.53028 20.75 6.97474 20.75H7.02526C7.46972 20.75 7.84075 20.75 8.14537 20.7292C8.46247 20.7076 8.76199 20.661 9.05238 20.5407C9.72621 20.2616 10.2616 19.7262 10.5407 19.0524C10.661 18.762 10.7076 18.4625 10.7292 18.1454C10.75 17.8408 10.75 17.4697 10.75 17.0253V16.9747C10.75 16.5303 10.75 16.1592 10.7292 15.8546C10.7076 15.5375 10.661 15.238 10.5407 14.9476C10.2616 14.2738 9.72621 13.7384 9.05238 13.4593C8.76199 13.339 8.46247 13.2924 8.14537 13.2708ZM5.52165 14.8452C5.5988 14.8132 5.71602 14.7837 5.95674 14.7673C6.20421 14.7504 6.5238 14.75 7 14.75C7.4762 14.75 7.7958 14.7504 8.04326 14.7673C8.28399 14.7837 8.4012 14.8132 8.47836 14.8452C8.78464 14.972 9.02798 15.2154 9.15485 15.5216C9.18681 15.5988 9.21629 15.716 9.23271 15.9567C9.24959 16.2042 9.25 16.5238 9.25 17C9.25 17.4762 9.24959 17.7958 9.23271 18.0433C9.21629 18.284 9.18681 18.4012 9.15485 18.4784C9.02798 18.7846 8.78464 19.028 8.47836 19.1549C8.4012 19.1868 8.28399 19.2163 8.04326 19.2327C7.7958 19.2496 7.4762 19.25 7 19.25C6.5238 19.25 6.20421 19.2496 5.95674 19.2327C5.71602 19.2163 5.5988 19.1868 5.52165 19.1549C5.21536 19.028 4.97202 18.7846 4.84515 18.4784C4.81319 18.4012 4.78372 18.284 4.76729 18.0433C4.75041 17.7958 4.75 17.4762 4.75 17C4.75 16.5238 4.75041 16.2042 4.76729 15.9567C4.78372 15.716 4.81319 15.5988 4.84515 15.5216C4.97202 15.2154 5.21536 14.972 5.52165 14.8452Z"
      fill="#667085"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1454 13.2708C17.8408 13.25 17.4697 13.25 17.0253 13.25H16.9747C16.5303 13.25 16.1592 13.25 15.8546 13.2708C15.5375 13.2924 15.238 13.339 14.9476 13.4593C14.2738 13.7384 13.7384 14.2738 13.4593 14.9476C13.339 15.238 13.2924 15.5375 13.2708 15.8546C13.25 16.1592 13.25 16.5303 13.25 16.9747V17.0253C13.25 17.4697 13.25 17.8408 13.2708 18.1454C13.2924 18.4625 13.339 18.762 13.4593 19.0524C13.7384 19.7262 14.2738 20.2616 14.9476 20.5407C15.238 20.661 15.5375 20.7076 15.8546 20.7292C16.1592 20.75 16.5303 20.75 16.9747 20.75H17.0253C17.4697 20.75 17.8408 20.75 18.1454 20.7292C18.4625 20.7076 18.762 20.661 19.0524 20.5407C19.7262 20.2616 20.2616 19.7262 20.5407 19.0524C20.661 18.762 20.7076 18.4625 20.7292 18.1454C20.75 17.8408 20.75 17.4697 20.75 17.0253V16.9747C20.75 16.5303 20.75 16.1592 20.7292 15.8546C20.7076 15.5375 20.661 15.238 20.5407 14.9476C20.2616 14.2738 19.7262 13.7384 19.0524 13.4593C18.762 13.339 18.4625 13.2924 18.1454 13.2708ZM15.5216 14.8452C15.5988 14.8132 15.716 14.7837 15.9567 14.7673C16.2042 14.7504 16.5238 14.75 17 14.75C17.4762 14.75 17.7958 14.7504 18.0433 14.7673C18.284 14.7837 18.4012 14.8132 18.4784 14.8452C18.7846 14.972 19.028 15.2154 19.1549 15.5216C19.1868 15.5988 19.2163 15.716 19.2327 15.9567C19.2496 16.2042 19.25 16.5238 19.25 17C19.25 17.4762 19.2496 17.7958 19.2327 18.0433C19.2163 18.284 19.1868 18.4012 19.1549 18.4784C19.028 18.7846 18.7846 19.028 18.4784 19.1549C18.4012 19.1868 18.284 19.2163 18.0433 19.2327C17.7958 19.2496 17.4762 19.25 17 19.25C16.5238 19.25 16.2042 19.2496 15.9567 19.2327C15.716 19.2163 15.5988 19.1868 15.5216 19.1549C15.2154 19.028 14.972 18.7846 14.8452 18.4784C14.8132 18.4012 14.7837 18.284 14.7673 18.0433C14.7504 17.7958 14.75 17.4762 14.75 17C14.75 16.5238 14.7504 16.2042 14.7673 15.9567C14.7837 15.716 14.8132 15.5988 14.8452 15.5216C14.972 15.2154 15.2154 14.972 15.5216 14.8452Z"
      fill="#667085"
    />
  </svg>
);
export const SvgWidgetFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.14537 3.27077C7.84076 3.24999 7.46972 3.24999 7.02527 3.25H6.97475C6.53029 3.24999 6.15925 3.24999 5.85464 3.27077C5.53754 3.29241 5.23801 3.33905 4.94762 3.45933C4.27379 3.73844 3.73844 4.27379 3.45933 4.94762C3.33905 5.23801 3.29241 5.53754 3.27077 5.85464C3.24999 6.15925 3.24999 6.53028 3.25 6.97474V7.02525C3.24999 7.46971 3.24999 7.84076 3.27077 8.14537C3.29241 8.46247 3.33905 8.76199 3.45933 9.05238C3.73844 9.72621 4.27379 10.2616 4.94762 10.5407C5.23801 10.661 5.53754 10.7076 5.85464 10.7292C6.15925 10.75 6.53028 10.75 6.97474 10.75H7.02526C7.46972 10.75 7.84075 10.75 8.14537 10.7292C8.46247 10.7076 8.76199 10.661 9.05238 10.5407C9.72621 10.2616 10.2616 9.72621 10.5407 9.05238C10.661 8.76199 10.7076 8.46247 10.7292 8.14537C10.75 7.84075 10.75 7.46972 10.75 7.02526V6.97474C10.75 6.53028 10.75 6.15925 10.7292 5.85464C10.7076 5.53754 10.661 5.23801 10.5407 4.94762C10.2616 4.27379 9.72621 3.73844 9.05238 3.45933C8.76199 3.33905 8.46247 3.29241 8.14537 3.27077Z"
      fill="#7C68FB"
    />
    <path
      d="M17.75 4C17.75 3.58579 17.4142 3.25 17 3.25C16.5858 3.25 16.25 3.58579 16.25 4V6.25H14C13.5858 6.25 13.25 6.58579 13.25 7C13.25 7.41421 13.5858 7.75 14 7.75H16.25V10C16.25 10.4142 16.5858 10.75 17 10.75C17.4142 10.75 17.75 10.4142 17.75 10V7.75H20C20.4142 7.75 20.75 7.41421 20.75 7C20.75 6.58579 20.4142 6.25 20 6.25H17.75V4Z"
      fill="#7C68FB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.14537 13.2708C7.84075 13.25 7.46972 13.25 7.02526 13.25H6.97474C6.53028 13.25 6.15925 13.25 5.85464 13.2708C5.53754 13.2924 5.23801 13.339 4.94762 13.4593C4.27379 13.7384 3.73844 14.2738 3.45933 14.9476C3.33905 15.238 3.29241 15.5375 3.27077 15.8546C3.24999 16.1592 3.24999 16.5303 3.25 16.9747V17.0253C3.24999 17.4697 3.24999 17.8408 3.27077 18.1454C3.29241 18.4625 3.33905 18.762 3.45933 19.0524C3.73844 19.7262 4.27379 20.2616 4.94762 20.5407C5.23801 20.661 5.53754 20.7076 5.85464 20.7292C6.15925 20.75 6.53028 20.75 6.97474 20.75H7.02526C7.46972 20.75 7.84075 20.75 8.14537 20.7292C8.46247 20.7076 8.76199 20.661 9.05238 20.5407C9.72621 20.2616 10.2616 19.7262 10.5407 19.0524C10.661 18.762 10.7076 18.4625 10.7292 18.1454C10.75 17.8408 10.75 17.4697 10.75 17.0253V16.9747C10.75 16.5303 10.75 16.1592 10.7292 15.8546C10.7076 15.5375 10.661 15.238 10.5407 14.9476C10.2616 14.2738 9.72621 13.7384 9.05238 13.4593C8.76199 13.339 8.46247 13.2924 8.14537 13.2708Z"
      fill="#7C68FB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1454 13.2708C17.8408 13.25 17.4697 13.25 17.0253 13.25H16.9747C16.5303 13.25 16.1592 13.25 15.8546 13.2708C15.5375 13.2924 15.238 13.339 14.9476 13.4593C14.2738 13.7384 13.7384 14.2738 13.4593 14.9476C13.339 15.238 13.2924 15.5375 13.2708 15.8546C13.25 16.1592 13.25 16.5303 13.25 16.9747V17.0253C13.25 17.4697 13.25 17.8408 13.2708 18.1454C13.2924 18.4625 13.339 18.762 13.4593 19.0524C13.7384 19.7262 14.2738 20.2616 14.9476 20.5407C15.238 20.661 15.5375 20.7076 15.8546 20.7292C16.1592 20.75 16.5303 20.75 16.9747 20.75H17.0253C17.4697 20.75 17.8408 20.75 18.1454 20.7292C18.4625 20.7076 18.762 20.661 19.0524 20.5407C19.7262 20.2616 20.2616 19.7262 20.5407 19.0524C20.661 18.762 20.7076 18.4625 20.7292 18.1454C20.75 17.8408 20.75 17.4697 20.75 17.0253V16.9747C20.75 16.5303 20.75 16.1592 20.7292 15.8546C20.7076 15.5375 20.661 15.238 20.5407 14.9476C20.2616 14.2738 19.7262 13.7384 19.0524 13.4593C18.762 13.339 18.4625 13.2924 18.1454 13.2708Z"
      fill="#7C68FB"
    />
  </svg>
);
export const SvgSetting = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 9.5C13.3809 9.5 14.5 10.6191 14.5 12C14.5 13.3809 13.3809 14.5 12 14.5C10.6191 14.5 9.5 13.3809 9.5 12C9.5 10.6191 10.6191 9.5 12 9.5Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.168 7.25025V7.25025C19.4845 6.05799 17.9712 5.65004 16.7885 6.33852C15.7598 6.93613 14.4741 6.18838 14.4741 4.99218C14.4741 3.61619 13.3659 2.5 11.9998 2.5V2.5C10.6337 2.5 9.52546 3.61619 9.52546 4.99218C9.52546 6.18838 8.23977 6.93613 7.21199 6.33852C6.02829 5.65004 4.51507 6.05799 3.83153 7.25025C3.14896 8.4425 3.55399 9.96665 4.73769 10.6541C5.76546 11.2527 5.76546 12.7473 4.73769 13.3459C3.55399 14.0343 3.14896 15.5585 3.83153 16.7498C4.51507 17.942 6.02829 18.35 7.21101 17.6625H7.21199C8.23977 17.0639 9.52546 17.8116 9.52546 19.0078V19.0078C9.52546 20.3838 10.6337 21.5 11.9998 21.5V21.5C13.3659 21.5 14.4741 20.3838 14.4741 19.0078V19.0078C14.4741 17.8116 15.7598 17.0639 16.7885 17.6625C17.9712 18.35 19.4845 17.942 20.168 16.7498C20.8515 15.5585 20.4455 14.0343 19.2628 13.3459H19.2618C18.2341 12.7473 18.2341 11.2527 19.2628 10.6541C20.4455 9.96665 20.8515 8.4425 20.168 7.25025Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SvgSettingFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.75 12C9.75 10.7574 10.7574 9.75002 12 9.75002C13.2426 9.75002 14.25 10.7574 14.25 12C14.25 13.2427 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2427 9.75 12Z"
      fill="#7C68FB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.58523 3.2323C9.56564 -0.203083 14.4342 -0.203084 15.4147 3.2323C15.7184 4.2967 16.812 4.92806 17.8857 4.65893C21.351 3.7903 23.7853 8.00664 21.3004 10.5734C20.5305 11.3687 20.5305 12.6314 21.3004 13.4266C23.7853 15.9934 21.351 20.2097 17.8857 19.3411C16.812 19.072 15.7184 19.7033 15.4147 20.7677C14.4342 24.2031 9.56564 24.2031 8.58523 20.7677C8.28146 19.7033 7.18792 19.072 6.11423 19.3411C2.6489 20.2097 0.214599 15.9934 2.69952 13.4266C3.46944 12.6314 3.46944 11.3687 2.69952 10.5734C0.214599 8.00664 2.6489 3.7903 6.11423 4.65893C7.18792 4.92806 8.28146 4.2967 8.58523 3.2323ZM12 8.25002C9.92893 8.25002 8.25 9.92895 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92895 14.0711 8.25002 12 8.25002Z"
      fill="#7C68FB"
    />
  </svg>
);
export const SvgDataApi = () => (
  <svg width="24" height="24" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 5C13.5304 5 14.0391 4.78929 14.4142 4.41421C14.7893 4.03914 15 3.53043 15 3C15 2.46957 14.7893 1.96086 14.4142 1.58579C14.0391 1.21071 13.5304 1 13 1C12.4696 1 11.9609 1.21071 11.5858 1.58579C11.2107 1.96086 11 2.46957 11 3C11 3.53043 11.2107 4.03914 11.5858 4.41421C11.9609 4.78929 12.4696 5 13 5ZM13 5V6C13 8.5 11 9 11 9L5 11C5 11 3 11.5 3 14V15M3 5C3.53043 5 4.03914 4.78929 4.41421 4.41421C4.78929 4.03914 5 3.53043 5 3C5 2.46957 4.78929 1.96086 4.41421 1.58579C4.03914 1.21071 3.53043 1 3 1C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3C1 3.53043 1.21071 4.03914 1.58579 4.41421C1.96086 4.78929 2.46957 5 3 5ZM3 5V15M3 15C3.53043 15 4.03914 15.2107 4.41421 15.5858C4.78929 15.9609 5 16.4696 5 17C5 17.5304 4.78929 18.0391 4.41421 18.4142C4.03914 18.7893 3.53043 19 3 19C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17C1 16.4696 1.21071 15.9609 1.58579 15.5858C1.96086 15.2107 2.46957 15 3 15Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SvgDataApiFilled = () => (
  <svg width="24" height="24" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 5C13.5304 5 14.0391 4.78929 14.4142 4.41421C14.7893 4.03914 15 3.53043 15 3C15 2.46957 14.7893 1.96086 14.4142 1.58579C14.0391 1.21071 13.5304 1 13 1C12.4696 1 11.9609 1.21071 11.5858 1.58579C11.2107 1.96086 11 2.46957 11 3C11 3.53043 11.2107 4.03914 11.5858 4.41421C11.9609 4.78929 12.4696 5 13 5ZM13 5V6C13 8.5 11 9 11 9L5 11C5 11 3 11.5 3 14V15M3 5C3.53043 5 4.03914 4.78929 4.41421 4.41421C4.78929 4.03914 5 3.53043 5 3C5 2.46957 4.78929 1.96086 4.41421 1.58579C4.03914 1.21071 3.53043 1 3 1C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3C1 3.53043 1.21071 4.03914 1.58579 4.41421C1.96086 4.78929 2.46957 5 3 5ZM3 5V15M3 15C3.53043 15 4.03914 15.2107 4.41421 15.5858C4.78929 15.9609 5 16.4696 5 17C5 17.5304 4.78929 18.0391 4.41421 18.4142C4.03914 18.7893 3.53043 19 3 19C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17C1 16.4696 1.21071 15.9609 1.58579 15.5858C1.96086 15.2107 2.46957 15 3 15Z"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SvgVisitors = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7619 16.5269C11.3809 15.8243 12.619 15.8243 13.2381 16.5269C13.8571 17.2296 13.2381 21.6804 12.8254 22.1487C12.4127 22.6171 11.5873 22.6171 11.1746 22.1487C10.7619 21.6804 10.1428 17.2295 10.7619 16.5269Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4834 15.2565C16.7145 14.2479 17.5 12.7156 17.5 11C17.5 7.96245 15.0375 5.5 12 5.5C8.96245 5.5 6.5 7.96245 6.5 11C6.5 12.7156 7.28555 14.2479 8.5166 15.2565"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9629 19.0828C18.9464 17.6172 21 14.5484 21 11C21 6.02945 16.9706 2 12 2C7.02945 2 3 6.02945 3 11C3 14.5484 5.0536 17.6172 8.0371 19.0828"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SvgVisitorsFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"
      fill="#7C68FB"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7619 16.5269C11.3809 15.8243 12.619 15.8243 13.2381 16.5269C13.8571 17.2296 13.2381 21.6804 12.8254 22.1487C12.4127 22.6171 11.5873 22.6171 11.1746 22.1487C10.7619 21.6804 10.1428 17.2295 10.7619 16.5269Z"
      fill="#7C68FB"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4834 15.2565C16.7145 14.2479 17.5 12.7156 17.5 11C17.5 7.96245 15.0375 5.5 12 5.5C8.96245 5.5 6.5 7.96245 6.5 11C6.5 12.7156 7.28555 14.2479 8.5166 15.2565"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9629 19.0828C18.9464 17.6172 21 14.5484 21 11C21 6.02945 16.9706 2 12 2C7.02945 2 3 6.02945 3 11C3 14.5484 5.0536 17.6172 8.0371 19.0828"
      stroke="#7C68FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgWand = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.25 12V16.5" stroke="#667085" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 14.25H22.5" stroke="#667085" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.875 3.75V7.5" stroke="#667085" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 5.625H9.75" stroke="#667085" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.75 17.25V20.25" stroke="#667085" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.25 18.75H17.25" stroke="#667085" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17.4776 3.52862L3.53656 17.4697C3.24366 17.7626 3.24366 18.2374 3.53656 18.5303L5.47557 20.4693C5.76847 20.7622 6.24334 20.7622 6.53623 20.4693L20.4773 6.5283C20.7702 6.2354 20.7702 5.76053 20.4773 5.46764L18.5383 3.52862C18.2454 3.23572 17.7705 3.23572 17.4776 3.52862Z"
      stroke="#667085"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M13.5 7.5L16.5 10.5" stroke="#667085" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SvgWandFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.25 12V16.5" stroke="#7C68FB" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 14.25H22.5" stroke="#7C68FB" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.875 3.75V7.5" stroke="#7C68FB" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 5.625H9.75" stroke="#7C68FB" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.75 17.25V20.25" stroke="#7C68FB" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.25 18.75H17.25" stroke="#7C68FB" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17.4776 3.52862L3.53656 17.4697C3.24366 17.7626 3.24366 18.2374 3.53656 18.5303L5.47557 20.4693C5.76847 20.7622 6.24334 20.7622 6.53623 20.4693L20.4773 6.5283C20.7702 6.2354 20.7702 5.76053 20.4773 5.46764L18.5383 3.52862C18.2454 3.23572 17.7705 3.23572 17.4776 3.52862Z"
      fill="#7C68FB"
      stroke="#7C68FB"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M13.5 7.5L16.5 10.5" stroke="white" strokeWidth="1.2" strokeLinecap="square" strokeLinejoin="round" />
  </svg>
);
export const SvgDictionary = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2140_1942)">
      <path
        d="M20 3V21H12H7C5.34315 21 4 19.6566 4 17.9997C4 16.9646 4 16.0003 4 15.75V6C4 4.34315 5.34315 3 7 3H20Z"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 14.9995H7C5.34315 14.9995 4 16.3431 4 18V18"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9 8.00049H15" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_2140_1942">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgDictionaryFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2140_1902)">
      <path
        d="M20 3V21H12H7C5.34315 21 4 19.6566 4 17.9997C4 16.9646 4 16.0003 4 15.75V6C4 4.34315 5.34315 3 7 3H20Z"
        fill="#7C68FB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 3.75C5.75736 3.75 4.75 4.75736 4.75 6V17.9997C4.75 19.2425 5.75745 20.25 7 20.25H19.25V3.75H7ZM3.25 6C3.25 3.92893 4.92893 2.25 7 2.25H20C20.4142 2.25 20.75 2.58579 20.75 3V21C20.75 21.4142 20.4142 21.75 20 21.75H7C4.92884 21.75 3.25 20.0707 3.25 17.9997V6Z"
        fill="#7C68FB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 17.75V17.9997C3.25 19.2265 3.83915 20.3159 4.75 21.0002C4.75 21.0001 4.75 21.0001 4.75 21V17.9995C4.75 16.7569 5.75736 15.7495 7 15.7495H20.75V14.2495H7C5.01277 14.2495 3.38658 15.7953 3.25817 17.75H3.25Z"
        fill="white"
      />
      <path d="M9 8.00049H15" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_2140_1902">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const SvgAdminConsole = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 21V3" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 13.5V21" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 16.5V21" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SvgDigitalHuman = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.89349 20.2942 0.89349 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM12 2C6.47715 2 2 6.47715 2 12C2 13.6497 2.39944 15.206 3.10689 16.5776C3.15073 16.6626 3.1644 16.7601 3.14366 16.8535L2.10227 21.5398C2.05463 21.7541 2.24585 21.9454 2.4602 21.8977L7.14648 20.8564C7.23984 20.8356 7.3374 20.8493 7.42239 20.8931C8.794 21.6006 10.3503 22 12 22C17.5228 22 22 17.5228 22 12C22 11.9354 21.9994 11.8709 21.9982 11.8066C21.9877 11.2544 21.4853 10.8622 20.9369 10.9273L20.894 10.9324C20.3692 10.9947 20 11.4715 20 12C20 16.4183 16.4183 20 12 20C10.6655 20 9.38248 19.6745 8.23428 19.0605L7.71146 18.7809C7.62712 18.7358 7.52942 18.7224 7.43605 18.7432L4.78756 19.3317C4.71611 19.3476 4.65237 19.2838 4.66825 19.2124L5.25681 16.5639C5.27755 16.4705 5.26416 16.3728 5.21906 16.2885L4.93949 15.7657C4.32549 14.6175 4 13.3345 4 12C4 7.58172 7.58172 4 12 4C12.3454 4 12.6852 4.02183 13.0184 4.06411C13.5663 4.13363 14.1116 3.81819 14.2492 3.28332C14.3868 2.74845 14.0649 2.19804 13.519 2.11477C13.0232 2.03916 12.5159 2 12 2ZM9.13776 12.9014C8.98607 12.4192 8.59023 12 8.08475 12C7.48566 12 6.98779 12.4915 7.11621 13.0767C7.60866 15.3206 9.60821 17 12 17C14.3918 17 16.3913 15.3206 16.8838 13.0767C17.0122 12.4915 16.5143 12 15.9153 12C15.4098 12 15.0139 12.4192 14.8622 12.9014C14.4796 14.1178 13.3428 15 12 15C10.6572 15 9.52044 14.1178 9.13776 12.9014Z"
      fill="#667085"
    />
  </svg>
);

export const SvgDigitalHumanFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.89349 20.2942 0.89349 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM12 2C6.47715 2 2 6.47715 2 12C2 13.6497 2.39944 15.206 3.10689 16.5776C3.15073 16.6626 3.1644 16.7601 3.14366 16.8535L2.10227 21.5398C2.05463 21.7541 2.24585 21.9454 2.4602 21.8977L7.14648 20.8564C7.23984 20.8356 7.3374 20.8493 7.42239 20.8931C8.794 21.6006 10.3503 22 12 22C17.5228 22 22 17.5228 22 12C22 11.9354 21.9994 11.8709 21.9982 11.8066C21.9877 11.2544 21.4853 10.8622 20.9369 10.9273L20.894 10.9324C20.3692 10.9947 20 11.4715 20 12C20 16.4183 16.4183 20 12 20C10.6655 20 9.38248 19.6745 8.23428 19.0605L7.71146 18.7809C7.62712 18.7358 7.52942 18.7224 7.43605 18.7432L4.78756 19.3317C4.71611 19.3476 4.65237 19.2838 4.66825 19.2124L5.25681 16.5639C5.27755 16.4705 5.26416 16.3728 5.21906 16.2885L4.93949 15.7657C4.32549 14.6175 4 13.3345 4 12C4 7.58172 7.58172 4 12 4C12.3454 4 12.6852 4.02183 13.0184 4.06411C13.5663 4.13363 14.1116 3.81819 14.2492 3.28332C14.3868 2.74845 14.0649 2.19804 13.519 2.11477C13.0232 2.03916 12.5159 2 12 2ZM9.13776 12.9014C8.98607 12.4192 8.59023 12 8.08475 12C7.48566 12 6.98779 12.4915 7.11621 13.0767C7.60866 15.3206 9.60821 17 12 17C14.3918 17 16.3913 15.3206 16.8838 13.0767C17.0122 12.4915 16.5143 12 15.9153 12C15.4098 12 15.0139 12.4192 14.8622 12.9014C14.4796 14.1178 13.3428 15 12 15C10.6572 15 9.52044 14.1178 9.13776 12.9014Z"
      fill="#7C68FB"
    />
  </svg>
);

export const SvgRealtime = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#667085"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M9 2m0 3a3 3 0 0 1 3 -3a3 3 0 0 1 3 3v5a3 3 0 0 1 -3 3a3 3 0 0 1 -3 -3z" />
    <path d="M5 10a7 7 0 0 0 14 0" />
    <path d="M8 21l8 0" />
    <path d="M12 17l0 4" />
  </svg>
);

export const SvgRealtimeFilled = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#7C68FB"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M9 2m0 3a3 3 0 0 1 3 -3a3 3 0 0 1 3 3v5a3 3 0 0 1 -3 3a3 3 0 0 1 -3 -3z" fill="#7C68FB" />
    <path d="M5 10a7 7 0 0 0 14 0" />
    <path d="M8 21l8 0" />
    <path d="M12 17l0 4" />
  </svg>
);

// 電話受付（phone-call：电话 + 来电波纹）
export const SvgPhoneReception = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#667085"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" />
    <path d="M15 6l5 -3" />
    <path d="M16 9l4 0" />
  </svg>
);

export const SvgPhoneReceptionFilled = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#7C68FB"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path
      d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
      fill="#7C68FB"
    />
    <path d="M15 6l5 -3" />
    <path d="M16 9l4 0" />
  </svg>
);

// 問い合わせ連携（Zendesk 回复环運営画面）
export const SvgTicket = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M15 5l0 2" />
    <path d="M15 11l0 2" />
    <path d="M15 17l0 2" />
    <path d="M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2" />
  </svg>
);

export const SvgTicketFilled = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <path d="M19 4a3 3 0 0 1 3 3v2a1 1 0 0 1 -1 1a2 2 0 0 0 0 4a1 1 0 0 1 1 1v2a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-2a1 1 0 0 1 1 -1a2 2 0 0 0 0 -4a1 1 0 0 1 -1 -1v-2a3 3 0 0 1 3 -3zm-4 12a1 1 0 0 0 -1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0 -1 -1zm0 -6a1 1 0 0 0 -1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0 -1 -1zm0 -6a1 1 0 0 0 -1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0 -1 -1z" />
  </svg>
);
